import BaseModel from "../models/BaseModel";
import TreeViewModel from "../models/TreeviewModel";
import type PageReference from "../models/PageReference";
import Logger from "../Logger";
import type Room from "../models/Room";
import type RoomTreeViewModel from "./RoomTreeviewModel";
import { itx } from "../translationItx/itx";

const logger = new Logger();

export default class PageReferenceTreeViewModel extends TreeViewModel {
  constructor(obj: BaseModel) {
    super(obj);
  }

  get typedObj(): PageReference {
    return this.obj as PageReference;
  }

  get isFolder(): boolean {
    return false;
  }

  get isSelectable(): boolean {
    return false;
  }

  getDisableEdit(): boolean {
    return true;
  }

  getTagNeeded(): boolean {
    return true;
  }

  allowDrag(): boolean {
    return true;
  }

  handleOpen(): boolean {
    if (this.typedObj.className == "PdfPageReference") {
      // Open the parent PDF page in the unified UploadedPdfViewer and navigate
      // to the specific page number via subPageId (appended as #page=N to the blob URL).
      const parentPage = this.typedObj.referencedPage;
      const pageNumber = (this.typedObj as any).pageNumber as number;
      const parentId = parentPage?.id;

      if (parentId) {
        // Close any existing pane for this page so the new subPageId triggers
        // a fresh React mount (and therefore a fresh #page=N iframe src).
        if (state.activePanes.isOpen(parentId)) {
          state.activePanes.closePane(parentId);
        }
        state.activePanes.loadPage(parentId, String(pageNumber));
      }
      return true;
    }

    const id = this.typedObj.referencedPage?.id;
    if (id) {
      if (state.activePanes.isOpen(id)) {
        state.activePanes.activatePane(id);
      } else {
        state.activePanes.loadPage(id);
      }
    }
    return true;
  }

  getButtons(): JSX.Element[] | undefined {
    if ((this.obj as PageReference).referencedPage?.isRoomOrFloorPlan) {
      return [];
    }
    return [super.inlineButton_Open("inlineButton.openDocument")]; // no itx
  }

  getFullTitle(isExpanded: boolean): string | undefined | JSX.Element {
    const room = this.typedObj.referencedPage?.parent as Room;
    if (room?.className == "Room" && (room?.treeViewModel as RoomTreeViewModel).isFloorGeneral()) {
      return (
        <div style={{ fontStyle: "italic" }}>
          {itx("roomTreeViewModel.generalFloor", "Etage allgemein")} {room.parent?.displayName}
        </div>
      );
    }
    return undefined;
  }

  get contextMenuItems(): any {
    var subLabelPaste = undefined;

    try {
      subLabelPaste = state.contextMenuManager.clipboardData.items[0].name;
    } catch (ex) {
      logger.error(ex);
    }

    return {
      items: [
        // this.baseContextMenuItems_Delete(),

        {
          id: "open",
          iconName: "edit", // no itx
          label: "inlineButton.openDocument", // no itx
          onClick: () => this.handleOpen(),
        },
      ],
    };
  }
}
